const VERCEL_ENVIRONMENT = process.env.NEXT_PUBLIC_VERCEL_ENV ?? null;

export const POSTHOG_DEPLOYMENT = {
  // Built previews also have NODE_ENV=production; only an explicit preview/development deployment or a local dev server may bypass the production consent flow.
  isAutomaticCaptureEnabled:
    VERCEL_ENVIRONMENT === "preview" ||
    VERCEL_ENVIRONMENT === "development" ||
    (VERCEL_ENVIRONMENT === null && process.env.NODE_ENV === "development"),
  properties: {
    deployment_environment:
      VERCEL_ENVIRONMENT ??
      (process.env.NODE_ENV === "development" ? "development" : null),
    git_branch: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF ?? null,
    git_commit_sha: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? null,
  },
};
